export default __webpack_public_path__ + "images/8ff0429930552966f12f50e4d1572aec-cte.svg";